// extracted by mini-css-extract-plugin
export default {"thumb":"SummaryTemplate-module__[local]___ogTqc"};